module.exports = "img/flags/JM.f82c626.png";